<template>
  <UIButton
    v-if="!isReadonly"
    v-tooltip="disabledTooltip"
    :disabled
    :size
    :leading="ArrowDownOnSquareIcon"
    :label="unlabeled ? undefined : 'Save changes'"
    variant="danger"
  />
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { ButtonSize, ReadonlyMode } from '@types'

import { READONLY_MODE } from '@/const/common'

import { ArrowDownOnSquareIcon } from '@heroicons/vue/24/outline'

import { UIButton } from '@ui/buttons'

type Props = {
  unlabeled?: boolean
  disabled?: boolean
  disabledTooltip?: string
}

const { unlabeled, disabled, disabledTooltip } = defineProps<Props>()

const size = inject<ButtonSize>('size')
const isReadonly = inject<ReadonlyMode>(READONLY_MODE)
</script>
